import { Pais } from './Pais';
import { Localitat } from './localitat';
import { EstudisRealitzats } from './estudiRealitzat';

export class Alumne {

    public isnew = true;
    public id: number;
    public tipusDocument = 1;
    public documentIdentificatiu: string;
    public sexe = 1;
    public nom: string;
    public cognom1: string;
    public cognom2: string;
    public adreca: string;
    public codiPostal: string;
    public mobil: string;
    public email: string;
    public pais: Pais;
    public poblacio: Localitat;
    public poblacioText: string;
    public nacionalitat: Pais;
    public dataNaixement: string;
    public paisNaixement: Pais;
    public poblacioNaixement: Localitat;
    public poblacioNaixementText: string;
    public discapacitat = false;

    constructor() {}

    paisEspanya(): boolean {
        if (this.pais == null) {
            return false;
        }
        return this.pais.value === 72;
    }

    paisNaixementEspanya(): boolean {
        if (this.paisNaixement == null) {
            return false;
        }
        return this.paisNaixement.value === 72;
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/model/alumne.ts